import React from 'react';
import { Facebook, Instagram, Twitter, Linkedin, Youtube, MapPin, Mail, Phone, Shield } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import navItems from '../data/navItems';
import ROLFLogo from './ROLFLogo';

const Footer = () => {
  const navigate = useNavigate();

  const handleNavigate = (path) => {
    navigate(path);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-grid">
          <div className="footer-brand">
            <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', marginBottom: '0.5rem' }}>
              {/* <ROLFLogo size={40} /> */}
              <div>
                <div style={{ color: '#fff', fontFamily: 'var(--font-heading)', fontSize: '1.125rem', fontWeight: 700 }}>
                  Realm of Love Foundation
                </div>
              </div>
            </div>
            <p>Empowering communities through education, wellness, and sustainable development across South Africa.</p>
            <div className="footer-social">
              <a href="https://facebook.com" aria-label="Facebook"><Facebook size={18} /></a>
              <a href="https://instagram.com" aria-label="Instagram"><Instagram size={18} /></a>
              <a href="https://twitter.com" aria-label="Twitter"><Twitter size={18} /></a>
              <a href="https://linkedin.com" aria-label="LinkedIn"><Linkedin size={18} /></a>
              <a href="https://youtube.com" aria-label="YouTube"><Youtube size={18} /></a>
            </div>
          </div>

          <div>
            <h4 className="footer-heading">Quick Links</h4>
            {navItems.map(item => (
              <button key={item.id} className="footer-link" onClick={() => handleNavigate(item.path)}>
                {item.label}
              </button>
            ))}
          </div>

          <div>
            <h4 className="footer-heading">Programmes</h4>
            <button className="footer-link" onClick={() => handleNavigate('/programmes')}>Education Access</button>
            <button className="footer-link" onClick={() => handleNavigate('/programmes')}>Health & Wellness</button>
            <button className="footer-link" onClick={() => handleNavigate('/programmes')}>Youth Empowerment</button>
            <button className="footer-link" onClick={() => handleNavigate('/programmes')}>Community Dev</button>
            <button className="footer-link" onClick={() => handleNavigate('/programmes')}>Food Security</button>
          </div>

          <div>
            <h4 className="footer-heading">Contact</h4>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
              {/* <div style={{ display: 'flex', alignItems: 'flex-start', gap: '0.5rem' }}>
                <MapPin size={16} style={{ marginTop: '3px', flexShrink: 0, color: 'var(--teal)' }} />
                <span className="footer-link" style={{ cursor: 'default' }}>Johannesburg, Gauteng, South Africa</span>
              </div> */}
              <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                <Mail size={16} style={{ flexShrink: 0, color: 'var(--teal)' }} />
                <a className="footer-link" href="mailto:support@realmoflove.org">support@realmoflove.org</a>
              </div>
              {/* <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                <Phone size={16} style={{ flexShrink: 0, color: 'var(--teal)' }} />
                <a className="footer-link" href="tel:+27123456789">+27 12 345 6789</a>
              </div> */}
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <span>&copy; {new Date().getFullYear()} Realm of Love Foundation. All rights reserved.</span>
          <span className="footer-npo">
            <Shield size={12} />
            NPO Reg: 2021/766891/08
          </span>
          <div style={{ display: 'flex', gap: '1.5rem' }}>
            <button className="footer-link" style={{ display: 'inline' }}>Privacy Policy</button>
            <button className="footer-link" style={{ display: 'inline' }}>Terms of Service</button>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
